import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, Button, Card, Badge, Row, Col } from 'react-bootstrap';
import { BASE_URL } from '../../services/Api';
import { authHeader } from '../../services/auth-header';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { FaArrowLeft, FaEdit } from 'react-icons/fa';

const PIssueSlipView = () => {
    const { id, pointindex } = useParams();
    const navigate = useNavigate();
    const [issueSlipData, setIssueSlipData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchIssueSlipData = async () => {
            try {
                const response = await axios.get(`${BASE_URL}materialissueslip/${id}`, {
                    headers: authHeader()
                });
                setIssueSlipData(response.data);
                setLoading(false);
            } catch (err) {
                console.error("Error fetching issue slip data", err);
                setError(err.message);
                setLoading(false);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to fetch issue slip data',
                    confirmButtonText: 'OK'
                }).then(() => {
                    navigate(-1);
                });
            }
        };

        fetchIssueSlipData();
    }, [id]);

    if (loading) {
        return (
            <div className="container mt-4">
                <div className="text-center">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p>Loading material issue slip data...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="container mt-4">
                <div className="alert alert-danger" role="alert">
                    Error loading material issue slip: {error}
                </div>
                <Button variant="secondary" onClick={() => navigate(-1)}>
                    Go Back
                </Button>
            </div>
        );
    }

    if (!issueSlipData) {
        return (
            <div className="container mt-4">
                <div className="alert alert-warning" role="alert">
                    No material issue slip data found
                </div>
                <Button variant="secondary" onClick={() => navigate(-1)}>
                    Go Back
                </Button>
            </div>
        );
    }

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString();
    };

    const getStaffNames = (staffArray) => {
        if (!staffArray || staffArray.length === 0) return 'N/A';
        return staffArray.map(staff => staff.firstname).join(', ');
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
        });

        if (result.isConfirmed) {
            try {
                const response = await axios.delete(`${BASE_URL}materialissueslip/${id}`, {
                    headers: authHeader(),
                });
                navigate(`/issue-slip-list/${pointindex}`);
                Swal.fire('Deleted!', 'material issue slip successfully.', 'success');
            } catch (error) {
                // If there is an error, display it
                Swal.fire('Error', error.response?.data || 'An error occurred', 'error');
            }
        }
    };


    return (
        <div className="Container">
            <Card className="card">
                <Card.Header className="card-header">
                    <h6>Type: {issueSlipData.type}</h6>
                    <h6>Material Issue Slip - View</h6>
                    <div className="d-flex justify-content-end gap-2 mb-4">
                        {/* {data?.status === 'open' && ( */}
                        <Link to={`/IssueSlipUpdate/${id}/${pointindex}`}>
                            <Button variant="primary" className="me-2" size='sm'> <FaEdit className="me-2" />UPDATE</Button>
                        </Link>
                        {/* )} */}

                        {/* Delete button */}
                        {/* {data?.status === 'open' && ( */}
                        <Button variant="danger" className="me-2" size='sm' onClick={() => handleDelete(id)}>DELETE</Button>
                        {/* )} */}
                        <Link to={`/issue-slip-list/${pointindex}`}>
                            <Button variant="outline-secondary" className="me-2" size='sm'> <FaArrowLeft className="me-2" />BACK TO LIST</Button>
                        </Link>
                    </div>
                </Card.Header>
                <div className="container mt-4">

                    <Card className="mb-4 shadow-sm">
                        <Card.Header>
                            <h5>Basic Information</h5>
                            <Badge bg={issueSlipData.stocktype === 'inward' ? 'success' : 'primary'} className="ms-2">
                                {issueSlipData.stocktype.toUpperCase()}
                            </Badge>
                        </Card.Header>
                        <Card.Body>
                            <Row>
                                <Col md={6}><strong>Production Order No:</strong> {issueSlipData.productionordernumber}</Col>
                                <Col md={6}><strong>Production Order No:</strong> {issueSlipData.partno}</Col>
                                <Col md={6}><strong>Production Order No:</strong> {issueSlipData.jobnumber}</Col>
                                <Col md={6}><strong>Issue Slip Date:</strong> {issueSlipData.issueslipdate}</Col>
                                <Col md={6} className="mt-3"><strong>Issued By:</strong> {issueSlipData.issuedby?.map(user => user.firstname).join(', ')}</Col>
                                <Col md={6} className="mt-3"><strong>Received By:</strong> {issueSlipData.receivedby?.map(user => user.firstname).join(', ')}</Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    {issueSlipData.materialissuewithbomrawsemiservicespump?.length > 0 && (
                        <Card className="mb-4">
                            <Card.Header>
                                <h5>Pump Raw/Semi Product Items</h5>
                            </Card.Header>
                            <Card.Body>
                                <div className="table-responsive">
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Part Name</th>
                                                <th>Material Size</th>
                                                <th>MOC</th>
                                                <th>Required Qty</th>
                                                <th>Issued Qty</th>
                                                <th>unit of measurement</th>
                                                <th>Remarks</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {issueSlipData.materialissuewithbomrawsemiservicespump.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.description || 'N/A'}</td>
                                                    <td>{item.materialsize || 'N/A'}</td>
                                                    <td>{item.moc || 'N/A'}</td>
                                                    <td>{item.requiredquantity || '0'}</td>
                                                    <td>{item.issuedquantity || '0'}</td>
                                                    <td>{item.uom || 'N/A'}</td>
                                                    <td>{item.remark || 'N/A'}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </Card.Body>
                        </Card>
                    )}
                </div>
            </Card>
        </div>
    );
};

export default PIssueSlipView;